import { useEffect, useState } from 'react';
import { fetchCheckupsByChassisList } from '../../../api/fetchCheckup';
import { fetchMaintenanceDetails } from '../../../api/fetchMaintenance';
import type { Asset } from '../../../models/asset';
import { toAssetSummaries } from '../monitoringUtils';

const useVehicleFullDetails = (asset: Asset | undefined) => {
    const [details, setDetails] = useState<Asset | null>(null);
    const [loading, setLoading] = useState(false);
    const assetId = asset?.id;

    useEffect(() => {
        setDetails(null);
        if (!asset) {
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);

        const load = async () => {
            try {
                const list = await fetchMaintenanceDetails(toAssetSummaries([asset]));
                const base = list.find(item => item.id === asset.id) ?? asset;
                const checkups = await fetchCheckupsByChassisList([base.chassis], [base]);
                const checkup = checkups.find(item => item.chassis === base.chassis);
                if (!cancelled) {
                    setDetails({
                        ...asset,
                        ...base,
                        schedulings: {
                            previous: checkup?.previous ?? base.schedulings?.previous ?? [],
                            next: checkup?.next ?? base.schedulings?.next ?? [],
                        },
                    });
                }
            } catch {
                if (!cancelled) {
                    setDetails(asset);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        load();

        return () => {
            cancelled = true;
        };
    }, [assetId]);

    return { details, loading };
};

export default useVehicleFullDetails;
